import * as React from 'react';
import { ReactElement } from 'react';
import cn from 'classnames';

import './RatingStar.pcss';

interface Props {
  value: number;
  rating: number;
  onClick: (value: number) => void;
  onMouseEnter: (value: number) => void;
  onMouseLeave: (value: number) => void;
  ratingHighlighted: number;
  className?: string;
}

const RatingStar = ({
  value,
  rating,
  onClick,
  ratingHighlighted,
  onMouseEnter,
  onMouseLeave,
  className,
}: Props): ReactElement => {
  const classNames = cn(
    'RatingStar',
    {
      RatingStar_selected: value <= rating,
      RatingStar_highlighted:
        ratingHighlighted &&
        value <= ratingHighlighted &&
        (value === ratingHighlighted || value > rating),
    },
    className
  );

  return (
    <div
      onClick={() => onClick(value)}
      onMouseEnter={() => onMouseEnter(value)}
      onMouseLeave={() => onMouseLeave(value)}
      className={classNames}
    />
  );
};

export default RatingStar;
